import React, { useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { authFetch } from "@/lib/authFetch";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/reports/location-cleanup`;
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Builds the CRM-verified location cleanup report (takes ~1 min) and downloads it as CSV
export const LocationReportButton = () => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await authFetch(API, { method: "POST", credentials: "include" });
      let status = {};
      for (let i = 0; i < 60; i++) {
        await wait(5000);
        status = await (await authFetch(API, { credentials: "include" })).json();
        if (status.status !== "running") break;
      }
      if (status.status !== "ready") throw new Error("Report is still building — try again in a minute");
      const blob = await (await authFetch(`${API}.csv`, { credentials: "include" })).blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `location_cleanup_report_${(status.generated_at || "").slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success(`${status.rows} fixes across ${status.contacts} contacts`);
    } catch (e) {
      toast.error(e.message || "Could not build the report");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button size="sm" variant="outline" onClick={run} disabled={busy} data-testid="location-report-btn">
      <FileDown className="h-4 w-4 mr-2" />
      {busy ? "Checking CRM… (~1 min)" : "Location Cleanup Report"}
    </Button>
  );
};
